/**
 * Almondos mix-and-match bundle — automatic tiered savings.
 * No tier selection. Total bag count determines the discount rate shown,
 * matching the 5 automatic Shopify discounts (Auto Tier: 4+/5+/8+/10+/15+ Bags).
 * The actual discount is applied by Shopify at checkout — this is a live
 * price preview only.
 */
(function () {
  var RUNGS = [
    { qty: 4, pct: 5 },
    { qty: 5, pct: 6 },
    { qty: 8, pct: 8 },
    { qty: 10, pct: 10 },
    { qty: 15, pct: 15 },
  ];

  function rungForCount(count) {
    var best = null;
    for (var i = 0; i < RUNGS.length; i++) {
      if (RUNGS[i].qty <= count) best = RUNGS[i];
    }
    return best;
  }

  function nextRungForCount(count) {
    for (var i = 0; i < RUNGS.length; i++) {
      if (RUNGS[i].qty > count) return RUNGS[i];
    }
    return null;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initBuilder(root) {
    var flavorRows = root.querySelectorAll('[data-flavor-row]');
    var rungEls = root.querySelectorAll('[data-rung-qty]');
    var totalBagsEl = root.querySelector('[data-total-bags]');
    var savingsBadge = root.querySelector('[data-savings-badge]');
    var savingsPctEl = root.querySelector('[data-savings-pct]');
    var progressFill = root.querySelector('[data-progress-fill]');
    var progressHint = root.querySelector('[data-progress-hint]');
    var estTotalEl = root.querySelector('[data-est-total]');
    var savingsLine = root.querySelector('[data-savings-line]');
    var savingsAmountEl = root.querySelector('[data-savings-amount]');
    var addBtn = root.querySelector('[data-bundle-add]');
    var errorEl = root.querySelector('[data-bundle-error]');

    function qtyForRow(row) {
      var input = row.querySelector('[data-qty-input]');
      return input ? parseInt(input.value, 10) || 0 : 0;
    }

    function unitPriceCentsForRow(row) {
      return parseFloat(row.dataset.unitPriceCents) || 0;
    }

    function totalBags() {
      var n = 0;
      flavorRows.forEach(function (row) {
        n += qtyForRow(row);
      });
      return n;
    }

    function subtotalCents() {
      var cents = 0;
      flavorRows.forEach(function (row) {
        cents += qtyForRow(row) * unitPriceCentsForRow(row);
      });
      return cents;
    }

    function updateUI() {
      var count = totalBags();
      var subtotal = subtotalCents();
      var rung = rungForCount(count);
      var nextRung = nextRungForCount(count);

      if (totalBagsEl) totalBagsEl.textContent = String(count);

      rungEls.forEach(function (el) {
        var qty = parseInt(el.dataset.rungQty, 10);
        var active = rung && qty === rung.qty;
        el.classList.toggle('ring-2', !!active);
        el.classList.toggle('ring-primary', !!active);
      });

      var pct = rung ? rung.pct : 0;
      var discountCents = Math.round(subtotal * (pct / 100));
      var totalCents = subtotal - discountCents;

      if (savingsBadge) savingsBadge.hidden = !rung;
      if (savingsPctEl && rung) savingsPctEl.textContent = String(rung.pct);

      if (estTotalEl) estTotalEl.textContent = formatMoney(totalCents);

      if (savingsLine) savingsLine.hidden = !rung || discountCents <= 0;
      if (savingsAmountEl) savingsAmountEl.textContent = formatMoney(discountCents);

      if (progressFill) {
        var ceiling = nextRung ? nextRung.qty : (rung ? rung.qty : RUNGS[0].qty);
        var pctFill = Math.min(100, Math.round((count / ceiling) * 100));
        progressFill.style.width = pctFill + '%';
      }

      if (progressHint) {
        if (nextRung) {
          var remaining = nextRung.qty - count;
          progressHint.textContent =
            remaining > 0
              ? 'Add ' + remaining + ' more bag' + (remaining === 1 ? '' : 's') + ' to unlock ' + nextRung.pct + '% off.'
              : '';
          progressHint.hidden = remaining <= 0;
        } else if (rung) {
          progressHint.hidden = false;
          progressHint.textContent = "You're at the top tier — " + rung.pct + '% off your whole order.';
        } else {
          progressHint.hidden = false;
          progressHint.textContent = 'Add 4 bags to unlock your first discount.';
        }
      }

      if (errorEl) errorEl.hidden = true;
      if (addBtn) addBtn.disabled = count < 1;
    }

    flavorRows.forEach(function (row) {
      var minus = row.querySelector('[data-qty-minus]');
      var plus = row.querySelector('[data-qty-plus]');
      var input = row.querySelector('[data-qty-input]');
      function bump(delta) {
        var v = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = String(v);
        updateUI();
      }
      if (minus) minus.addEventListener('click', function () { bump(-1); });
      if (plus) plus.addEventListener('click', function () { bump(1); });
      if (input) input.addEventListener('change', updateUI);
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        flavorRows.forEach(function (row) {
          var q = qtyForRow(row);
          if (q > 0) {
            items.push({ id: row.dataset.variantId, quantity: q });
          }
        });
        if (!items.length) return;
        addBtn.disabled = true;
        addBtn.classList.add('loading');

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200) {
              throw new Error(data.description || data.message || 'Could not add to bag');
            }
            // No discount code redirect needed — the matching automatic
            // discount (Auto Tier: 4+/5+/8+/10+/15+ Bags) applies itself
            // at checkout based on cart quantity.
            window.location.href = '/cart';
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message || 'Something went wrong. Try again.';
              errorEl.hidden = false;
            }
            addBtn.disabled = false;
            addBtn.classList.remove('loading');
          });
      });
    }

    updateUI();
  }

  function initAll() {
    document.querySelectorAll('[data-alm-bundle-builder]:not([data-alm-bundle-initialized])').forEach(function (root) {
      try {
        root.setAttribute('data-alm-bundle-initialized', 'true');
        initBuilder(root);
      } catch (err) {
        console.error('[Almondos] Bundle builder failed to initialize:', err);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  window.AlmBundle = { rungForCount: rungForCount, RUNGS: RUNGS, initAll: initAll };
})();
